import { queryOptions } from "@tanstack/react-query";
import type { PublicDocument, TherapistContract } from "@/types/document";
import { apiUrl } from "@/lib/api-url";

/**
 * Aktivna verzija javnog dokumenta (ugovor, uslovi, etički kodeks). Sadržaj
 * mijenja samo admin kroz Dokumente, pa ga držimo dugo u kešu.
 */
export const publicDocumentQueryOptions = (type: string) =>
  queryOptions({
    queryKey: ["public-document", type],
    staleTime: 10 * 60 * 1000,
    queryFn: async (): Promise<PublicDocument> => {
      const res = await fetch(apiUrl(`/api/documents/public/${type}`));
      if (!res.ok) throw new Error("Dokument nije dostupan");
      return res.json();
    },
  });

/**
 * Aktivni ugovor prijavljenog terapeuta sa popunjenim placeholderima i stanjem
 * prihvatanja. 404 znači da admin nema aktivan `ugovor_terapeut`; to nije
 * greška nego "nema ugovora", pa je vraćamo kao `null`.
 */
export const therapistContractQueryOptions = () =>
  queryOptions({
    queryKey: ["therapist", "contract"],
    staleTime: 60 * 1000,
    queryFn: async (): Promise<TherapistContract | null> => {
      const res = await fetch(apiUrl("/api/therapist/contract"));
      if (res.status === 404) return null;
      if (!res.ok) throw new Error("Ugovor nije dostupan");
      return res.json();
    },
  });
